import * as core from '../core';

export declare interface BaseBoundData {
  user: { id?: string; email?: string };
}

export enum TrackingModule {
  cadastre = 'cadastre',
}

export declare interface BaseEvent {
  // Events are typically added in tranches. Each time a new set of events is added, the tranche number
  // for that set should be incremented.
  // This allows for tracking overall activity trends using conditions like trackingEventTrancheNumber < 2,
  // making it easier to compare periods using same set of events.
  trackingEventTrancheNumber: number;

  // Optional tracking module attribute can be used to easily group events falling into certain product module
  trackingModule?: TrackingModule;

  [x: string]: any;
}

export class BaseTracker<BoundData extends BaseBoundData> {
  boundData: BoundData;

  constructor(boundData: BoundData) {
    this.boundData = boundData;
  }

  track(eventName: string, eventAttributes: BaseEvent) {
    core.track(eventName, eventAttributes);
  }
}
